import { call, put, takeLatest } from "redux-saga/effects";
import { paperEdit } from "../../../services/paper";
import { networkErrorHandler } from "../../../utils/errorHandlers";

import { editPaperStart, editPaperSuccess, editPaperFailure } from "../reducer";
import { successNotifier } from "../../../utils/helpers";

export function* editPaper({ payload }) {
  const { data, callback } = payload;

  const response = yield call(paperEdit, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editPaperSuccess());
    successNotifier("Paper edited successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(editPaperFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw);
  }
}

export default function* onEditPaper() {
  yield takeLatest(editPaperStart.type, editPaper);
}
